import { render, staticRenderFns } from "./KasbonApprovalView.vue?vue&type=template&id=d8759120"
import script from "./KasbonApprovalView.vue?vue&type=script&lang=js"
export * from "./KasbonApprovalView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports